import React from "react";
import Joi from "joi-browser";
import Form from "../common/form";
import { saveLedgerType } from "../../services/visaLedgerTypeService";
import { toast } from "react-toastify";
import BlockUi from "react-block-ui";
import { Table } from "semantic-ui-react";
import TableTitle from "../common/tableTitle";
import { Link } from "react-router-dom";

class VisaTypeForm extends Form {
  state = {
    data: {
      name: "",
    },
    errors: {},
  };

  schema = {
    id: Joi.string(),
    name: Joi.string().required().label("Ledger type"),
  };

  doSubmit = async () => {
    try {
      this.setState({ blocking: true });
      await saveLedgerType(this.state.data);
      toast.success("Ledger type has been added successfully.");
      this.setState({ blocking: false });
      this.props.history.push("/visas-ledgers-types");
    } catch (ex) {
      console.log(ex.response);
      if (ex.response && ex.response.status === 422) {
        const errors = { ...this.state.errors };

        if (ex.response.data.errors.name)
          errors.name = ex.response.data.errors.name;

        this.setState({ errors, blocking: false });
        //toast.warning("check validation errors.");
      }
    }
  };

  render() {
    const dashboardIcon = process.env.REACT_APP_URL + "/new_theme/visa.png";
    return (
      <BlockUi tag="div" blocking={this.state.blocking}>
        <h1 className="container__heading">Add visa ledger type</h1>
        <button
          className="btn btn--secondary"
          onClick={() => this.props.history.push("/visas-ledgers-types")}
        >
          Back
        </button>
        <form onSubmit={this.handleSubmit}>
          <div className="card form">
            <div className="form__content">
              <h3 className="card__heading">Add visa ledger type</h3>
              <p>Provide the information below to add the ledger type.</p>
              {this.renderInput("name", "Ledger type", "text")}

              {this.renderButton("Save")}
            </div>
          </div>
        </form>
      </BlockUi>
    );
  }
}

export default VisaTypeForm;
